<template>
    <v-menu offset-y>
        <template v-slot:activator="{ on }">
            <v-btn
                    v-on="on"
                    text
                    style="margin: 0 10px"
            >
                <v-icon>mdi-radar</v-icon>
                radars
            </v-btn>
        </template>

        <v-list dense>
            <v-list-item-group>
                <v-list-item v-for="(radar, i) in radars" :key="i" @click="open(radar)">
                    <v-list-item-icon>
                        <v-icon>mdi-radar</v-icon>
                    </v-list-item-icon>
                    <v-list-item-content>
                        <v-list-item-title v-text="radar.name"></v-list-item-title>
                    </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-menu>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'RadarSelect',
    computed: {
      ...mapGetters({
        radars: 'radars/getRadars'
      })
    },
    methods: {
      open (radar) {
        this.$store.commit('blobs/clearCurrentBlobId')
        this.$router.push({ name: 'radar', params: { radarId: radar.id } }).catch(() => {})
      }
    }

  }
</script>
